import styled, { keyframes } from 'styled-components'


const ripple = keyframes`
    0% {
        box-shadow: 0 0 0 0 rgba(226, 226, 226, 0.3),
                    0 0 0 0.5em rgba(226, 226, 226, 0.3),
                    0 0 0 1.2em rgba(226, 226, 226, 0.3),
                    0 0 0 2em rgba(226, 226, 226, 0.3);
    }
    100% {
        box-shadow: 0 0 0 0.5em rgba(226, 226, 226, 0.3),
                    0 0 0 1.2em rgba(226, 226, 226, 0.3),
                    0 0 0 2em rgba(226, 226, 226, 0.3),
                    0 0 0 2.5em rgba(226, 226, 226, 0);
    }
`;

const Avatar = styled.div`
    height: 124px;
    width: 110px;
    border-radius: 50%;
    & img {
        border-radius: 50%;
        height: 60px;
        width: 60px;
        animation: ${ripple} 0.7s linear infinite;
    }
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Title = styled.h1`
    margin-top: 20px !important;
    margin-bottom: 12px;
    line-height: 1.5;
    color: #151a43;
    text-transform: ${props => props.capitalize ? 'capitalize' : 'none'};
    font-family: Lato;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;

`
const SubTitle = styled.p`
    white-space: pre-wrap;
    margin-top: 0;
    margin-bottom: ${props => props.marginBottom || '44px'};
    font-size: 16px;
    color: #545876;
    line-height: 1.5;
`

const ImageWrapper = styled.div`
    background-color: #ffbe1d;
    width: 60px;
    height: 60px;
    border-radius: 50%;
`


export {
    Avatar, Title, SubTitle, ImageWrapper
}